import { Keyword } from 'models/Keyword';
import { shuffleArray } from 'helpers/shuffleArray';

const MAX_KEYWORD_LIST_SIZE = 20;

export function processKeywords(keywords: Keyword[]) {
  if (!keywords || !Array.isArray(keywords) || keywords.length === 0) {
    return;
  }

  shuffleArray(keywords);
  keywords?.splice(MAX_KEYWORD_LIST_SIZE);
}
